import React, { useState, useEffect } from 'react';

import Modal from 'react-bootstrap/Modal';
import CustomerFormZoho from './CustomerFormZoho.jsx';

export default function CustomerFormModal({ getMethods }) {

    const [ show, setShow ] = useState(false);

    useEffect(() => {
        getMethods({
            open: () => {
              setShow(true);
            }
        });
    }, []);

    const close = () => {
      setShow(false);
    };

    return (
      <>
        <Modal show={show} onHide={close}>
          <Modal.Header closeButton>
            <Modal.Title>Contacts and Leads</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CustomerFormZoho
              closeForm={close}
              />
          </Modal.Body>
        </Modal>
      </>
    );
};